export const HOME_ROUTE = "/";
export const LOGIN_ROUTE = "/login";
export const DASHBOARD_ROUTE = "/dashboard";
export const INVOICE_RESEND_ROUTE = "/dashboard/invoices/resend";
export const CONGRATESPAGE_ROUTE = "/congratespage";
export const CONGRATESTWOPAGE_ROUTE = "/congratestwopage";
export const ACCOUNTSETTINGPAGE_ROUTE = "/accountsettingpage";
export const MEMBERSHIPSETTINGPAGE_ROUTE = "/membershipsettingpage";
export const DEVICESHARINGPAGE_ROUTE = "/DeviceSharingPage";
export const PRIVACYANDSECURITYPAGE_ROUTE = "/privacyAndSecurityPage";
export const PRIVACYPASSWORD_ROUTE = "/privacyAndSecurityPage/password";
export const PRIVACY2FA_ROUTE = "/privacyAndSecurityPage/two-factor";

export const SIGNUP_ROUTE = "/signup";
export const USER_PROFILE_ROUTE = "/user-profile";
export const PROFILE_PREVIEW_ROUTE = "/profile-preview";
export const USER_PROFILE_INFORMATION_ROUTE = "/user-profile-info";
export const MESSAGES_ROUTE = "/messages";
